module.exports = __webpack_public_path__ + "img/nevsLogoEn.287a2b23.png";